import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmDialog } from '../../../../components/ConfirmDialog';
import { useMutation } from 'react-fetching-library';
import { getEmployeesAccountsAction } from '../../../../services/request';
import { useAccounts } from '../Context';

export default function Delete({ rowData }) {
  const ctx = useAccounts();
  const { mutate } = useMutation(getEmployeesAccountsAction);
  const [open, setOpen] = React.useState(false);

  const handleDelete = async () => {
    const { error } = await mutate('DELETE', rowData.id);
    if (!error) {
      ctx.query();
    } else {
      alert('Nie udało się usunąć użytkownika');
    }
  };

  return (
    <>
      <Tooltip title="Usuń">
        <IconButton
          color="error"
          onClick={() => setOpen(true)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      <ConfirmDialog
        title="Usunąć użytkownika?"
        open={open}
        setOpen={setOpen}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć uzytkownika o numerze {rowData.id}?
      </ConfirmDialog>
    </>
  );
};

